<template>
  <b-container>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <b-row>
        <b-col>
          <b-row>
            <b-col><b-form-input id="choice-filter" v-model="choicename" placeholder="Choice Search" @blur="fetchMenuChoices()"></b-form-input></b-col>
          </b-row>
          <b-row class="py-2">
            <b-col>
              <h5 style="text-align: center;">Add new Choice</h5>
            </b-col>
          </b-row>
          <b-row>
            <!-- <b-col cols="1">
              <a :href="'#'+$route.path"><b-icon icon="plus-circle" variant="primary" font-scale="2.5" v-b-popover.hover.left="'Add new Choice'" @click="addChoice()"></b-icon></a>
            </b-col> -->
            <b-col cols="8">
              <b-form-input v-model="newChoice.name" placeholder="Choice name"></b-form-input>
            </b-col>
            <b-col cols="4">
              <b-form-input id="add_price" v-model="newChoice.add_price" placeholder="Price"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="py-2">
            <b-col style="text-align:center;">
              <b-button variant="outline-dark" @click="addChoice()">Add</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="10"><b-alert v-if="newchoicealert" variant="info" v-model="newchoicealert" dismissible>Please enter an Choice name!</b-alert></b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <h5 style="text-align: center;">Edit Choices</h5>
            </b-col>
          </b-row>
          <b-list-group>
            <!-- <b-list-group-item>
              <b-row>
                <b-col cols="7">Name</b-col>
                <b-col cols="3">Extra price</b-col>
              </b-row>
            </b-list-group-item> -->
            <ChoiceList
              v-for="choice of choices"
              v-bind:choice="choice"
              v-bind:key="choice.id"
              @emit-fetch-choices="fetchMenuChoices"
              @emit-switch-overlay="switchOverlay">
            </ChoiceList>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination v-model="currentPage" :total-rows="total_choices" :per-page="limit" align="center" @change="showoverlay=true; fetchMenuChoices()"></b-pagination>
          <p style="text-align: center;">Total choices: {{ total_choices }}</p>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>

<script>
import ChoiceList from '@/components/ChoiceList.vue'
export default {
  name: "MenuChoices",
  components: {
    ChoiceList
  },
  data() {
    return {
      choices: [],
      total_choices: 0,
      limit: 50,
      currentPage: 1,
      showoverlay: false,
      newChoice: {
        name: '',
        add_price: ''
      },
      newchoicealert: false,
      beginoverlay: 0,
      choicename: ''
    };
  },

  computed: {
    // all pagination, filtering and sorting info collected here for housekeeping purposes
    urlext: function() {
      return "?page="+this.currentPage+"&limit="+this.limit+this.choicefilter;
    },

    choicefilter: function() {
      if (this.choicename) {
        return "&name="+this.choicename;
      } else {
        return '';
      }
    }
  },

  methods: {
    switchOverlay(bool) {
      this.showoverlay = bool;
    },

    async addChoice() {
      if (this.newChoice.name == '') {
        this.newchoicealert = true;
        return;
      }
      this.switchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      var body = {
        "name": this.newChoice.name,
        "add_price": this.newChoice.add_price
      }
      // update order with status of 'ready'
      const { data } = await this.$api.post('optionitems',
        body,
        config
      );
      if (data.created == true) {
        this.newChoice = [];
        this.fetchMenuChoices();
      } else {
        this.showoverlay=false;
        this.$bvModal.msgBoxOk('There was a problem adding the choice, please try again later.', {
          title: 'Error adding choice',
          centered: true
        })
      }
    },

    async fetchMenuChoices() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("optionitems"+this.urlext, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.switchOverlay(false);
      try {
        this.choices = data.optionitems;
        this.total_choices = data.total_optionitems;
        this.switchOverlay(false);
      } catch(e) {
        this.switchOverlay(false);
        console.log(e);
      }
    },

    overlayRoutine() {
      if (this.beginoverlay == 0) {
        this.showoverlay = true;
        this.beginoverlay = 1;
      }
    }

  },

  created: function() {
    // this.switchOverlay(true);
    this.fetchMenuChoices();
  }
}
</script>
